(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bracelet-size-selector"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('sinclairs-bracelet-sizer')) return;
  const selections = new Map();
  const isolated = 'quick-add-dialog,product-card,[data-quick-view]';
  class BraceletSizer extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.initialize());
    }
    initialize() {
      if (this.initialized || !this.isConnected) return;
      this.initialized = true;
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      this.key = `${location.pathname}:${this.id}:${this.dataset.productId}`;
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.choices = [...this.querySelectorAll('option,[data-size-radio]')].map(e => e.value);
      const saved = selections.get(this.key);
      this.value = this.choices.includes(saved) ? saved : this.querySelector('[data-size-select], [data-size-radio]:checked').value;
      this.guide = this.querySelector('dialog');
      const dropdown = this.querySelector('[data-size-select]');
      const selectWrap = this.querySelector('.sbs__select-wrap');
      let pointerFocus = false;
      if (dropdown && selectWrap) {
        dropdown.addEventListener('pointerdown', () => {
          pointerFocus = true;
          selectWrap.dataset.keyboardFocus = 'false';
        }, options);
        dropdown.addEventListener('focus', () => {
          selectWrap.dataset.keyboardFocus = String(!pointerFocus);
        }, options);
        dropdown.addEventListener('keydown', () => {
          pointerFocus = false;
          selectWrap.dataset.keyboardFocus = 'true';
        }, options);
        dropdown.addEventListener('blur', () => {
          pointerFocus = false;
          selectWrap.dataset.keyboardFocus = 'false';
        }, options);
      }
      this.addEventListener('change', e => {
        if (e.target.matches('[data-size-select],[data-size-radio]')) {
          this.value = e.target.value;
          this.update();
          this.syncForms();
        }
      }, options);
      this.querySelector('[data-guide-open]').addEventListener('click', () => {
        if (!this.guide.open) this.guide.showModal();
      }, options);
      this.querySelector('[data-guide-close]').addEventListener('click', () => this.closeGuide(), options);
      this.guide.addEventListener('cancel', e => {
        e.preventDefault();
        this.closeGuide();
      }, options);
      this.guide.addEventListener('click', e => {
        if (e.target !== this.guide) return;
        const r = this.guide.getBoundingClientRect();
        if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) this.closeGuide();
      }, options);
      this.guide.addEventListener('animationend', e => {
        if (e.target === this.guide && e.animationName === 'sbs-drawer-exit') this.finishClose();
      }, options);
      this.guide.addEventListener('close', () => {
        this.resetClose();
        this.querySelector('[data-guide-open]').focus({preventScroll:true});
      }, options);
      this.update();
      this.syncForms();
    }
    closeGuide() {
      if (!this.guide.open || this.guide.hasAttribute('data-closing')) return;
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.guide.close();
        return;
      }
      // Start from the current position, including an interrupted entrance.
      const drawerStyle = getComputedStyle(this.guide);
      const backdropStyle = getComputedStyle(this.guide, '::backdrop');
      this.guide.style.setProperty('--sbs-close-transform', drawerStyle.transform);
      this.guide.style.setProperty('--sbs-close-opacity', drawerStyle.opacity);
      this.guide.style.setProperty('--sbs-backdrop-opacity', backdropStyle.opacity);
      this.guide.setAttribute('data-closing', '');
      // Fallback if the theme disables animations or animationend is interrupted.
      this.closeTimer = setTimeout(() => this.finishClose(), 320);
    }
    finishClose() {
      if (!this.guide.hasAttribute('data-closing')) return;
      if (this.guide.open) this.guide.close();
      this.resetClose();
    }
    resetClose() {
      clearTimeout(this.closeTimer);
      this.closeTimer = null;
      this.guide?.removeAttribute('data-closing');
      ['--sbs-close-transform','--sbs-close-opacity','--sbs-backdrop-opacity'].forEach(key => this.guide?.style.removeProperty(key));
    }
    update() {
      selections.set(this.key, this.value);
      const select = this.querySelector('[data-size-select]');
      if (select) select.value = this.value;
      this.querySelectorAll('[data-size-radio]').forEach(e => {e.checked = e.value === this.value;});
      const summary = this.querySelector('[data-selected-size]');
      if (summary) summary.textContent = `${this.value} in`;
      this.querySelectorAll('[data-guide-size]').forEach(e => e.classList.toggle('is-current', e.dataset.guideSize === this.value));
    }
    matchesProduct(form) {
      if (!(form instanceof HTMLFormElement)) return false;
      if (!/\/cart\/add(?:[.?/]|$)/.test(form.action)) return false;
      if (form.closest(isolated) !== this.closest(isolated)) return false;
      const productId = form.querySelector('[name="product-id"]')?.value || form.dataset.productId;
      const variantId = form.querySelector('[name="id"]')?.value;
      if (productId) return String(productId) === this.dataset.productId;
      return this.variants.includes(String(variantId));
    }
    findForms() {
      if (this.dataset.formId) {
        const form = document.getElementById(this.dataset.formId);
        return this.matchesProduct(form) ? [form] : [];
      }
      const enclosing = this.closest('form');
      if (this.matchesProduct(enclosing)) return [enclosing];
      for (let scope = this.parentElement; scope && scope !== document.body; scope = scope.parentElement) {
        const forms = [...scope.querySelectorAll('form')].filter(f => this.matchesProduct(f));
        if (forms.length) return forms;
        if (scope.matches('.shopify-section') || scope.matches(isolated)) break;
      }
      return [];
    }
    syncForms() {
      if (!this.initialized) this.initialize();
      if (!this.initialized) return;
      const forms = this.findForms();
      document.querySelectorAll('input[data-bracelet-owner]').forEach(input => {
        if (input.dataset.braceletOwner === this.id && !forms.includes(input.form)) input.remove();
      });
      forms.forEach(form => {
        let input = [...form.querySelectorAll('input[data-bracelet-owner]')].find(e => e.dataset.braceletOwner === this.id);
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.dataset.braceletOwner = this.id;
          form.appendChild(input);
        }
        input.name = `properties[${this.dataset.propertyName}]`;
        input.value = `${this.value} in`;
      });
      this.querySelector('[data-connection-error]').hidden = forms.length > 0;
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.resetClose();
      if (this.guide?.open) this.guide.close();
      this.controller?.abort();
      document.querySelectorAll('input[data-bracelet-owner]').forEach(input => {
        if (input.dataset.braceletOwner === this.id) input.remove();
      });
      this.initialized = false;
    }
  }
  customElements.define('sinclairs-bracelet-sizer', BraceletSizer);
  const sync = () => document.querySelectorAll('sinclairs-bracelet-sizer').forEach(e => e.syncForms());
  document.addEventListener('submit', sync, true);
  document.addEventListener('click', e => {
    if (e.target instanceof Element && e.target.closest('button,input[type="submit"],shopify-accelerated-checkout,.shopify-payment-button')) sync();
  }, true);
  document.addEventListener('change', sync, true);
  document.addEventListener('shopify:section:load', sync);
  let pending = false;
  new MutationObserver(records => {
    if (pending || !records.some(r => [...r.addedNodes,...r.removedNodes].some(n => n instanceof Element && (n.matches('form,[name="id"],sinclairs-bracelet-sizer') || n.querySelector('form,[name="id"],sinclairs-bracelet-sizer'))))) return;
    pending = true;
    queueMicrotask(() => {pending = false; sync();});
  }).observe(document.documentElement, {childList:true,subtree:true});
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["diamond-details"] && !Shopify.designMode) return;
  try {
    (() => {
    const roots = '.ndd[data-ndd-product][data-ndd-option]';
    const isolated = 'quick-add-dialog, product-card, [data-quick-view]';
    const normalize = value => String(value || '').trim().toLowerCase();
    const formatCarat = value => String(value).replace(/\s*(?:carats?|cts?)\s*$/i, '').trim();

    function selectedControl(picker, root) {
      const optionName = normalize(root.dataset.nddOption);
      for (const control of picker.querySelectorAll('input[type="radio"]:checked, select')) {
        const chosen = control.tagName === 'SELECT' ? control.selectedOptions[0] : control;
        if (!chosen) continue;
        const explicitName = normalize(chosen.dataset.optionName || control.dataset.optionName);
        const name = normalize(control.name);
        if (explicitName === optionName || name === optionName ||
            name === `options[${optionName}]` ||
            name === `${optionName}-${root.dataset.nddPosition}`) return chosen;
      }
      return null;
    }

    function sync(root, changedPicker) {
      if (!root.dataset.nddProduct || !root.dataset.nddOption) return;
      const scope = root.closest(isolated);
      const candidates = changedPicker ? [changedPicker] : [...document.querySelectorAll('variant-picker')];
      for (const picker of candidates) {
        // A quick-add for the same product must not change the product-page card.
        if (picker.dataset.productId !== root.dataset.nddProduct || picker.closest(isolated) !== scope) continue;
        const chosen = selectedControl(picker, root);
        const output = root.querySelector('[data-ndd-carat]');
        if (!chosen || !output) continue;
        const value = formatCarat(chosen.value);
        if (value && output.textContent !== value) output.textContent = value;
        return;
      }
    }

    function syncAll(picker) {
      document.querySelectorAll(roots).forEach(root => sync(root, picker));
    }

    // Delegate so replacing the theme's variant-picker does not remove this listener.
    document.addEventListener('change', event => {
      if (!(event.target instanceof Element)) return;
      const picker = event.target.closest('variant-picker');
      if (picker) syncAll(picker);
    }, true);
    document.addEventListener('shopify:section:load', () => syncAll());
    window.addEventListener('pageshow', () => syncAll());

    function start() {
      syncAll();
      let queued = false;
      new MutationObserver(records => {
        const inserted = records.some(record => [...record.addedNodes].some(node =>
          node instanceof Element && (node.matches(`variant-picker, ${roots}`) ||
            node.querySelector(`variant-picker, ${roots}`))
        ));
        if (!inserted || queued) return;
        queued = true;
        queueMicrotask(() => { queued = false; syncAll(); });
      }).observe(document.body, { childList: true, subtree: true });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["necklace-pendant-size-selector"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('sinclairs-chain-sizer')) return;
  const selections = new Map();
  const isolated = 'quick-add-dialog,product-card,[data-quick-view]';
  class ChainSizer extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.initialize());
    }
    initialize() {
      if (this.initialized || !this.isConnected) return;
      this.initialized = true;
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      this.key = `${location.pathname}:${this.id}:${this.dataset.productId}`;
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.choices = [...this.querySelectorAll('option,[data-size-radio]')].map(e => e.value);
      const saved = selections.get(this.key);
      this.value = this.choices.includes(saved) ? saved : this.querySelector('[data-size-select], [data-size-radio]:checked').value;
      this.guide = this.querySelector('dialog');
      const dropdown = this.querySelector('[data-size-select]');
      const selectWrap = this.querySelector('.sns__select-wrap');
      let pointerFocus = false;
      if (dropdown && selectWrap) {
        dropdown.addEventListener('pointerdown', () => {
          pointerFocus = true;
          selectWrap.dataset.keyboardFocus = 'false';
        }, options);
        dropdown.addEventListener('focus', () => {
          selectWrap.dataset.keyboardFocus = String(!pointerFocus);
        }, options);
        dropdown.addEventListener('keydown', () => {
          pointerFocus = false;
          selectWrap.dataset.keyboardFocus = 'true';
        }, options);
        dropdown.addEventListener('blur', () => {
          pointerFocus = false;
          selectWrap.dataset.keyboardFocus = 'false';
        }, options);
      }
      this.addEventListener('change', e => {
        if (e.target.matches('[data-size-select],[data-size-radio]')) {
          this.value = e.target.value;
          this.update();
          this.syncForms();
        }
      }, options);
      this.querySelector('[data-guide-open]').addEventListener('click', () => {
        if (!this.guide.open) this.guide.showModal();
      }, options);
      this.querySelector('[data-guide-close]').addEventListener('click', () => this.closeGuide(), options);
      this.guide.addEventListener('cancel', e => {
        e.preventDefault();
        this.closeGuide();
      }, options);
      this.guide.addEventListener('click', e => {
        if (e.target !== this.guide) return;
        const r = this.guide.getBoundingClientRect();
        if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) this.closeGuide();
      }, options);
      this.guide.addEventListener('animationend', e => {
        if (e.target === this.guide && e.animationName === 'sns-drawer-exit') this.finishClose();
      }, options);
      this.guide.addEventListener('close', () => {
        this.resetClose();
        this.querySelector('[data-guide-open]').focus({preventScroll:true});
      }, options);
      this.update();
      this.syncForms();
    }
    closeGuide() {
      if (!this.guide.open || this.guide.hasAttribute('data-closing')) return;
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.guide.close();
        return;
      }
      // Start from the current position, including an interrupted entrance.
      const drawerStyle = getComputedStyle(this.guide);
      const backdropStyle = getComputedStyle(this.guide, '::backdrop');
      this.guide.style.setProperty('--sns-close-transform', drawerStyle.transform);
      this.guide.style.setProperty('--sns-close-opacity', drawerStyle.opacity);
      this.guide.style.setProperty('--sns-backdrop-opacity', backdropStyle.opacity);
      this.guide.setAttribute('data-closing', '');
      // Fallback if the theme disables animations or animationend is interrupted.
      this.closeTimer = setTimeout(() => this.finishClose(), 320);
    }
    finishClose() {
      if (!this.guide.hasAttribute('data-closing')) return;
      if (this.guide.open) this.guide.close();
      this.resetClose();
    }
    resetClose() {
      clearTimeout(this.closeTimer);
      this.closeTimer = null;
      this.guide?.removeAttribute('data-closing');
      ['--sns-close-transform','--sns-close-opacity','--sns-backdrop-opacity'].forEach(key => this.guide?.style.removeProperty(key));
    }
    update() {
      selections.set(this.key, this.value);
      const select = this.querySelector('[data-size-select]');
      if (select) select.value = this.value;
      this.querySelectorAll('[data-size-radio]').forEach(e => {e.checked = e.value === this.value;});
      const summary = this.querySelector('[data-selected-size]');
      if (summary) summary.textContent = `${this.value} in`;
      this.querySelectorAll('[data-guide-size]').forEach(e => e.classList.toggle('is-current', e.dataset.guideSize === this.value));
    }
    matchesProduct(form) {
      if (!(form instanceof HTMLFormElement)) return false;
      if (!/\/cart\/add(?:[.?/]|$)/.test(form.action)) return false;
      if (form.closest(isolated) !== this.closest(isolated)) return false;
      const productId = form.querySelector('[name="product-id"]')?.value || form.dataset.productId;
      const variantId = form.querySelector('[name="id"]')?.value;
      if (productId) return String(productId) === this.dataset.productId;
      return this.variants.includes(String(variantId));
    }
    findForms() {
      if (this.dataset.formId) {
        const form = document.getElementById(this.dataset.formId);
        return this.matchesProduct(form) ? [form] : [];
      }
      const enclosing = this.closest('form');
      if (this.matchesProduct(enclosing)) return [enclosing];
      for (let scope = this.parentElement; scope && scope !== document.body; scope = scope.parentElement) {
        const forms = [...scope.querySelectorAll('form')].filter(f => this.matchesProduct(f));
        if (forms.length) return forms;
        if (scope.matches('.shopify-section') || scope.matches(isolated)) break;
      }
      return [];
    }
    syncForms() {
      if (!this.initialized) this.initialize();
      if (!this.initialized) return;
      const forms = this.findForms();
      document.querySelectorAll('input[data-chain-owner]').forEach(input => {
        if (input.dataset.chainOwner === this.id && !forms.includes(input.form)) input.remove();
      });
      forms.forEach(form => {
        let input = [...form.querySelectorAll('input[data-chain-owner]')].find(e => e.dataset.chainOwner === this.id);
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.dataset.chainOwner = this.id;
          form.appendChild(input);
        }
        input.name = `properties[${this.dataset.propertyName}]`;
        input.value = `${this.value} in`;
      });
      this.querySelector('[data-connection-error]').hidden = forms.length > 0;
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.resetClose();
      if (this.guide?.open) this.guide.close();
      this.controller?.abort();
      document.querySelectorAll('input[data-chain-owner]').forEach(input => {
        if (input.dataset.chainOwner === this.id) input.remove();
      });
      this.initialized = false;
    }
  }
  customElements.define('sinclairs-chain-sizer', ChainSizer);
  const sync = () => document.querySelectorAll('sinclairs-chain-sizer').forEach(e => e.syncForms());
  document.addEventListener('submit', sync, true);
  document.addEventListener('click', e => {
    if (e.target instanceof Element && e.target.closest('button,input[type="submit"],shopify-accelerated-checkout,.shopify-payment-button')) sync();
  }, true);
  document.addEventListener('change', sync, true);
  document.addEventListener('shopify:section:load', sync);
  let pending = false;
  new MutationObserver(records => {
    if (pending || !records.some(r => [...r.addedNodes,...r.removedNodes].some(n => n instanceof Element && (n.matches('form,[name="id"],sinclairs-chain-sizer') || n.querySelector('form,[name="id"],sinclairs-chain-sizer'))))) return;
    pending = true;
    queueMicrotask(() => {pending = false; sync();});
  }).observe(document.documentElement, {childList:true,subtree:true});
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ring-engraving"] && !Shopify.designMode) return;
  try {
    (() => {
 const states=new WeakMap();
 const activeDrawers=new Set();
 function mobileViewport(dialog) {
   if (!matchMedia('(max-width:749px)').matches) {
     ['top','left','width','height'].forEach(k=>dialog.style.removeProperty(`--sce-${k}`));
     dialog.removeAttribute('data-keyboard-open');return;
   }
   const v=window.visualViewport;
   const height=v?.height || window.innerHeight;
   const keyboard=height < window.innerHeight * .78;
   const sheetHeight=Math.max(0,Math.min(height-8,keyboard ? height-8 : height*.88));
   dialog.style.setProperty('--sce-top',`${(v?.offsetTop || 0)+height-sheetHeight}px`);
   dialog.style.setProperty('--sce-left',`${v?.offsetLeft || 0}px`);
   dialog.style.setProperty('--sce-width',`${v?.width || window.innerWidth}px`);
   dialog.style.setProperty('--sce-height',`${sheetHeight}px`);
   dialog.toggleAttribute('data-keyboard-open',keyboard);
 }
 function lockPage(state) {
   const body=document.body, html=document.documentElement;
   const x=window.scrollX,y=window.scrollY;
   const keys=['position','top','left','width','overflow'];
   const previous=keys.map(k=>[k,body.style.getPropertyValue(k),body.style.getPropertyPriority(k)]);
   const overflow=[html.style.getPropertyValue('overflow'),html.style.getPropertyPriority('overflow')];
   body.style.position='fixed';body.style.top=`${-y}px`;body.style.left=`${-x}px`;body.style.width='100%';body.style.overflow='hidden';html.style.overflow='hidden';
   const events=new AbortController();
   let frame=0;
   const resize=()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(()=>mobileViewport(state.dialog));};
   window.addEventListener('resize',resize,{signal:events.signal});
   window.visualViewport?.addEventListener('resize',resize,{signal:events.signal});
   window.visualViewport?.addEventListener('scroll',resize,{signal:events.signal});
   mobileViewport(state.dialog);
   state.unlock=()=>{
     events.abort();cancelAnimationFrame(frame);
     previous.forEach(([k,v,p])=>v ? body.style.setProperty(k,v,p) : body.style.removeProperty(k));
     overflow[0] ? html.style.setProperty('overflow',...overflow) : html.style.removeProperty('overflow');
     const behavior=[html.style.getPropertyValue('scroll-behavior'),html.style.getPropertyPriority('scroll-behavior')];
     html.style.setProperty('scroll-behavior','auto','important');window.scrollTo(x,y);
     behavior[0] ? html.style.setProperty('scroll-behavior',...behavior) : html.style.removeProperty('scroll-behavior');
     activeDrawers.delete(state);state.unlock=null;
   };
   activeDrawers.add(state);
 }

 const isolated='quick-add-dialog, product-card, [data-quick-view]';
  function isCartForm(form) {
    return form instanceof HTMLFormElement && /\/cart\/add(?:[.?/]|$)/.test(form.action);
  }
  function identity(form, root, ids) {
    if (!isCartForm(form) || form.closest(isolated) !== root.closest(isolated)) return 'other';
    const productId = form.querySelector('[name="product-id"]')?.value || form.dataset.productId;
    const variantId = form.querySelector('[name="id"]')?.value;
    if (productId) return String(productId) === root.dataset.productId ? 'match' : 'other';
    if (variantId && ids.includes(String(variantId))) return 'match';
    // Some themes populate the variant ID only after initialisation.
    if (variantId) return 'other';
    return 'unknown';
  }
  function findForms(root, ids) {
    if (root.dataset.formId) {
      const form = document.getElementById(root.dataset.formId);
      return form && identity(form, root, ids) !== 'other' ? [form] : [];
    }
    const enclosing = root.closest('form');
    if (enclosing && identity(enclosing, root, ids) !== 'other') return [enclosing];
    for (let scope = root.parentElement; scope && scope !== document.body; scope = scope.parentElement) {
      const forms = [...scope.querySelectorAll('form')].filter(isCartForm);
      const confirmed = forms.filter(form => identity(form, root, ids) === 'match');
      if (confirmed.length) return confirmed;
      if (forms.length === 1 && identity(forms[0], root, ids) === 'unknown') return forms;
      if (scope.matches('.shopify-section') || scope.matches(isolated)) return [];
    }
    return [];
  }

 function connect(root,state) {
   const forms=findForms(root,state.ids);
   document.querySelectorAll('input[data-engraving-owner]').forEach(m => {
     if (m.dataset.engravingOwner===root.id && !forms.includes(m.form)) m.remove();
   });
   forms.forEach(form => {
     [['text',state.propertyName,state.saved?.text],['font','properties[Engraving font]',state.saved?.font]].forEach(([kind,name,value]) => {
       let mirror=[...form.querySelectorAll('input[data-engraving-owner]')].find(m => m.dataset.engravingOwner===root.id && m.dataset.engravingKind===kind);
       if (!mirror) { mirror=document.createElement('input');mirror.type='hidden';mirror.dataset.engravingOwner=root.id;mirror.dataset.engravingKind=kind;form.appendChild(mirror); }
       mirror.name=name;mirror.value=value || '';mirror.disabled=!state.saved;
     });
   });
   forms.forEach(form => {
     const paid=Boolean(state.saved && root.dataset.addonPaid==='true');
     // Reserve an unused index; keep other apps' additional items intact.
     const own=[...form.querySelectorAll('input[data-engraving-owner]')].find(m=>m.dataset.engravingOwner===root.id && m.dataset.engravingKind==='addon-id');
     let index=own?.name.match(/shopify-additional-items\[(\d+)\]/)?.[1];
     if(!index) {
       const used=new Set([...form.elements].map(e=>e.name?.match(/^shopify-additional-items\[(\d+)\]/)?.[1]).filter(Boolean));
       index=1;while(used.has(String(index)))index++;
     }
     const prefix=`shopify-additional-items[${index}]`;
     const fields={id:root.dataset.addonId,parent_id:form.querySelector('[name="id"]')?.value || '',quantity:form.querySelector('[name="quantity"]')?.value || '1','properties[Engraving]':state.saved?.text || '', 'properties[Engraving font]':state.saved?.font || ''};
     Object.entries(fields).forEach(([key,value])=>{
       let mirror=[...form.querySelectorAll('input[data-engraving-owner]')].find(m=>m.dataset.engravingOwner===root.id && m.dataset.engravingKind===`addon-${key}`);
       if(!mirror){mirror=document.createElement('input');mirror.type='hidden';mirror.dataset.engravingOwner=root.id;mirror.dataset.engravingKind=`addon-${key}`;form.appendChild(mirror);}
       mirror.name=key.startsWith('properties[') ? `${prefix}[properties]${key.slice(10)}` : `${prefix}[${key}]`;mirror.value=value;mirror.disabled=!paid;
     });
   });
   state.forms=forms;
   root.querySelector('[data-engraving-error]').hidden=Boolean(forms.length);
 }
 function init() {
   document.querySelectorAll('[data-engraving]').forEach(root => {
     let state=states.get(root);
     if (state) { connect(root,state);return; }
     const input=root.querySelector('[data-engraving-text]');
     const dialog=root.querySelector('[data-engraving-dialog]');
     const font=root.querySelector('[data-engraving-font]');
     let ids=[];try {ids=JSON.parse(root.querySelector('[data-engraving-variants]').textContent);} catch {}
     state={input,dialog,font,ids,propertyName:input.name,saved:null,forms:[],returnFocus:null};states.set(root,state);
     input.removeAttribute('name');
     // Draft fields never belong to the purchase form or its native validation.
     input.setAttribute('form',`${root.id}-draft-only`);
     function draft() {
       input.setCustomValidity(input.value.trim() ? '' : 'Enter your engraving text.');
       root.querySelector('[data-engraving-count]').textContent=`${input.value.length} / ${input.maxLength}`;
       const preview=root.querySelector('[data-engraving-preview]');
       if (preview) {preview.textContent=input.value || 'Your text here';preview.dataset.font=font.dataset.style;}
       root.querySelectorAll('[data-font-choice]').forEach(b => b.setAttribute('aria-pressed',String(b.dataset.fontChoice===font.value)));
     }
     function summary() {
       root.querySelector('[data-engraving-open]').checked=Boolean(state.saved);
       root.querySelector('.sce__plus').textContent=state.saved ? '✓' : '+';
       root.querySelector('[data-engraving-saved]').hidden=!state.saved;
       root.querySelector('[data-engraving-summary]').textContent=state.saved ? `“${state.saved.text}” · ${state.saved.font}` : '';
       root.querySelectorAll('[data-engraving-remove]').forEach(button => { button.hidden=!state.saved; });
       connect(root,state);
     }
     function open(trigger) {
       if (dialog.open) return;
       state.returnFocus=trigger;
       input.value=state.saved?.text || '';
       font.value=state.saved?.font || 'Classic serif';
       font.dataset.style=state.saved?.style || 'serif';
       draft();summary();lockPage(state);
       try { dialog.showModal(); } catch (error) { state.unlock?.(); throw error; }
       // Focus a non-text control: opening the drawer must not summon the keyboard.
       root.querySelector('[data-engraving-close]').focus({preventScroll:true});
     }
     root.querySelector('[data-engraving-open]').addEventListener('change',e => {
       if (e.currentTarget.checked) { open(e.currentTarget); e.currentTarget.checked=true; }
       else {
         state.saved=null;input.value='';font.value='Classic serif';font.dataset.style='serif';draft();summary();
         root.querySelector('[data-engraving-save-status]').textContent='Engraving removed.';
       }
     });
     root.querySelector('[data-engraving-edit]').addEventListener('click',e => open(e.currentTarget));
     root.querySelector('[data-engraving-close]').addEventListener('click',() => dialog.close());
     dialog.addEventListener('click',e => {
       if (e.target!==dialog) return;
       const r=dialog.getBoundingClientRect();
       if (e.clientX<r.left || e.clientX>r.right || e.clientY<r.top || e.clientY>r.bottom) dialog.close();
     });
     dialog.addEventListener('close',() => {
       input.blur();state.unlock?.();
       summary();
       // Unsaved input is discarded; saved properties are untouched.
       input.value=state.saved?.text || '';font.value=state.saved?.font || 'Classic serif';font.dataset.style=state.saved?.style || 'serif';draft();
       const target=state.returnFocus?.offsetParent ? state.returnFocus : root.querySelector('[data-engraving-open]');
       target.focus({preventScroll:true});
     });
     input.addEventListener('input',draft);
     root.querySelectorAll('[data-font-choice]').forEach(b => b.addEventListener('click',() => {font.value=b.dataset.fontChoice;font.dataset.style=b.dataset.style;draft();}));
     root.querySelector('[data-engraving-save]').addEventListener('click',() => {
       draft();connect(root,state);
       if (!input.checkValidity()) {input.reportValidity();return;}
       if (!state.forms.length) {root.querySelector('[data-engraving-error]').scrollIntoView({block:'nearest'});return;}
       if(root.dataset.addonPaid==='true' && root.dataset.addonAvailable!=='true') {
         input.setCustomValidity('Paid engraving is currently unavailable. Please remove engraving to continue.');input.reportValidity();return;
       }
       state.saved={text:input.value,font:font.value,style:font.dataset.style};summary();dialog.close();
       root.querySelector('[data-engraving-save-status]').textContent='Engraving saved for this item.';
     });
     root.querySelectorAll('[data-engraving-remove]').forEach(button => button.addEventListener('click',() => {
       state.saved=null; input.value=''; font.value='Classic serif'; font.dataset.style='serif'; draft(); summary();
       if (dialog.open) dialog.close();
       root.querySelector('[data-engraving-save-status]').textContent='Engraving removed.';
       root.querySelector('[data-engraving-open]').focus({preventScroll:true});
     }));
     summary();
   });
   // Remove mirrored values if an editor update removes their block.
   document.querySelectorAll('input[data-engraving-owner]').forEach(m => {if (!document.getElementById(m.dataset.engravingOwner)) m.remove();});
 }
 function start() {
   init();let pending=false;
   new MutationObserver(records => {
     activeDrawers.forEach(state=>{if(!state.dialog.isConnected) state.unlock?.();});
     if (pending || !records.some(r => [...r.addedNodes,...r.removedNodes].some(n => n instanceof Element && (n.matches('form,[data-engraving],[name="id"]') || n.querySelector('form,[data-engraving],[name="id"]'))))) return;
     pending=true;queueMicrotask(() => {pending=false;init();});
   }).observe(document.body,{childList:true,subtree:true});
 }
 // Read-only synchronization: never cancel clicks/submits or replace theme checkout.
 document.addEventListener('submit',init,true);
 document.addEventListener('click',e=>{if(e.target instanceof Element && e.target.closest('button,input[type="submit"],shopify-accelerated-checkout,.shopify-payment-button'))init();},true);
 document.addEventListener('input',e=>{if(e.target instanceof Element && e.target.matches('[name="quantity"],[name="id"]'))init();},true);
 document.addEventListener('change',init,true);
 document.addEventListener('shopify:section:load',init);
 document.addEventListener('change',e => {if(e.target instanceof Element && e.target.closest('variant-picker')) queueMicrotask(init);});
 if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
  } catch(e) { console.error(e); }
})();

})();
